import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SpotlightResponseFooterComponent } from '../shared/response-footer/response-footer.component';
import { SpotlightAvatarComponent } from '../shared/avatar/avatar.component';
import { isAvatarField, shouldHideField, getFieldLabel, formatValue } from './result-multi-column.constants';
import { getCounterIcon } from '../result-counter/result-counter.constants';

export interface ColumnData {
    key: string;
    label: string;
    value: any;
}

@Component({
    selector: 'spotlight-result-multi-column',
    standalone: true,
    imports: [
        CommonModule,
        SpotlightResponseFooterComponent,
        SpotlightAvatarComponent
    ],
    templateUrl: './result-multi-column.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SpotlightResultMultiColumnComponent {
    @Input() title: string = '';
    @Input() description: string = '';
    @Input() data: any = {};
    @Input() executionTimeMs: number = 0;

    getIcon(): string {
        return getCounterIcon(this.title);
    }

    getColumns(): ColumnData[] {
        if (!this.data) return [];

        return Object.keys(this.data)
            .filter(key => !shouldHideField(key))
            .map(key => ({
                key,
                label: getFieldLabel(key),
                value: this.data[key]
            }));
    }

    isAvatar(key: string): boolean {
        return isAvatarField(key);
    }

    formatColumnValue(value: any, key: string): string {
        return formatValue(value, key);
    }
}
